export default __webpack_public_path__ + "static/logbuild-0942be50ed57b5fb3ff14bfe3cc3d73c.png";